<template>
  <div class="expense-category">
    <label class="checkbox-container" v-if="!loading">
      <input type="checkbox" :checked="selected" @change="onCheck" />
      <span class="checkmark"></span>
    </label>

    <CircularLoadingSpinner class="loading-spinner" v-if="loading" />

    <div class="expense-info">
      <label class="text" @click="onCheck">
        <h5>
          {{
            $language.current
              | translateToCurrentLang(expense.categoryRef.nameEs, expense.categoryRef.nameEn)
          }}
        </h5>
        <span
          v-html="
            $options.filters.translateToCurrentLang(
              $language.current,
              expense.categoryRef.descriptionHtmlEs,
              expense.categoryRef.descriptionHtmlEn,
            )
          "
          v-if="organizationDetails.grantRequestAmountEnabled"
        ></span>
      </label>
      <template v-if="organizationDetails.grantRequestAmountEnabled">
        <md-field class="amount-field" v-if="selected">
          <md-icon>attach_money</md-icon>
          <label :style="{ fontSize: '0.8rem' }" v-translate
            >Amount requested for this expense</label
          >
          <md-input
            v-model="expense.amount"
            type="number"
            @input="onEnterAmount"
            @blur="$emit('fieldBlur')"
          />
        </md-field>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import CircularLoadingSpinner from '@/components/CircularLoadingSpinner'

export default {
  name: 'ExpenseComponent',
  components: {
    CircularLoadingSpinner,
  },
  props: {
    expense: {
      type: Object,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['currentRequest', 'organizationDetails']),
  },
  methods: {
    onCheck() {
      if (this.selected) {
        this.$emit('expense-unselected', this.expense)
      } else {
        this.$emit('expense-selected', this.expense)
      }
    },
    onEnterAmount() {
      this.$emit('amount-updated', this.expense)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.expense-category {
  display: flex;
  margin: 2rem 0;
  width: 100%;
}
.amount-field {
  width: 100%;
  color: $mid-gray;
}

/* Customize the label (the checkbox-container) */
.checkbox-container {
  display: block;
  position: relative;
  padding: 1.5rem;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: $soft-gray;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  background-color: $mid-gray;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  background-color: $black;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.expense-info {
  width: 100%;
}
.text {
  cursor: pointer;
}

.loading-spinner {
  width: 54px;
}
</style>
